/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { camelCase, cloneDeep, uniqueId } from 'lodash';

function handleInitialAdjustments({
  questionnaire,
  setFieldValue,
  globalQuestionnaire,
  accessRoleData,
  rolesData,
  setRolesGroup,
  setRootRoles,
}) {
  try {
    //ToDo something

  } catch (e) {
    console.log("ROLE - handleInitialAdjustments error", e)
  }
}

function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
}) {
  try {
    let saveFilteredQuestionnaire = false;
    if(question.idQuestion === 1980 && value?.idRole) {
      const updateQst = questionnaireUpdated.find(qst => qst.idQuestion === 1980);
      updateQst.answerJson = JSON.stringify(value);
      saveFilteredQuestionnaire = true;
    }
    
    if (saveFilteredQuestionnaire) setQuestionnaire(questionnaireUpdated);
  } catch (e) {
    console.log("ROLE - handleQuestionChange error", e)
  }
}

function addProfile({ questionnaire, setFieldValue, rolesGroup, setRolesGroup, mc }) {
  try {

    const qstProfile = questionnaire.find(question => question.idQuestion === 1980);
    const { idRole, roleName, idGroupParent, groupParentName, accessRoleItem } = JSON.parse(qstProfile.answerJson);
    const roleFinded = rolesGroup.find(rl=> rl.idRole === idRole);
    
    if(roleFinded){
      if (roleFinded.idGroupMembership && roleFinded?.isExpired) {
        setRolesGroup((prev) => prev.map(grpMembership => {
          if (grpMembership.idRole === idRole) {
            grpMembership.isExpired = false
          }
          return grpMembership;
        }));
        setFieldValue(qstProfile.key, '');
        return;
      }

      mc.error("Este perfil já está na lista.");
      return;
    }

    const role ={
      idRole, 
      roleName, 
      idGroupParent, 
      groupParentName,
      accessRoleItem,
      idDomain: 307
    }
    
    setRolesGroup((prev) => [...prev, role]);  
    setFieldValue(qstProfile.key, '');

  } catch (e) {
    console.log('ROLE - addProfile error', e)
  }

}

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  addProfile
}

export { events };